import { GetServerSidePropsContext } from "next";
import { useRouter } from "next/router";

import GeneralHead from "@logics/tags/GeneralHead";
import { loadLocaleProps } from "@logics/utils/i18n";
import { useGuardWebView } from "@logics/hooks/useGuardWebView";
import { NAVIGATION_ROUTE } from "@domains/common/constants/navigationRoute";
import StayIntroductionComponent from "@domains/project/views/StayIntroduction/StayIntroduction";

const StayIntroductionPage = () => {
  const { replace } = useRouter();

  useGuardWebView({
    redirectCallback: () =>
      replace({
        href: NAVIGATION_ROUTE.HOME.HREF,
      }),
  });

  return (
    <>
      <GeneralHead
        page={{ title: "Stay Introduction" }}
        openGraph={{ title: "Stay Introduction" }}
      />

      <StayIntroductionComponent />
    </>
  );
};

export default StayIntroductionPage;

export async function getServerSideProps(context: GetServerSidePropsContext) {
  return {
    props: {
      ...(await loadLocaleProps(context)),
    },
  };
}
